import styled from "styled-components"
import { Row, Col, Accordion } from "react-bootstrap";
import { BPSAccordionStyled } from "../styled/BPSAccordion";

import HighFive from '../../assets/images/Home - High Five.png';
import Exciting from '../../assets/images/Home - Exciting Reliable.png';
import UserFriendly from '../../assets/images/Home - User Friendly.png';

import { BPSCheckmarkList, Checkmark } from "../styled/Lists";


const HomeAccordion1 = () => {
    return (
        <BPSAccordionStyled>
            <Accordion defaultActiveKey="0" >
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Fast deployment for immediate results</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            We get results fast. Between our white-labeled program sites and our amazing team of technology experts, we can have your program up and running in less than 90 days. Need it faster? Just let us know; we aim to please. Some of our programs go live in as little as 30 days!
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Only good surprises</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            With our affordable, transparent pricing and robust reporting options, you’ll never be in the dark. You won’t have to worry about surprise fees or unexpected costs. Our clients are thrilled by how quickly they achieve their goals and how high of an ROI they receive.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header>Infinitely scalable</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            No matter how big your aspirations are, we can provide you with the right solution. Our fully customized platforms blend seamlessly with your brand and can rapidly grow alongside it. Working together, the sky is the limit.
                        </p>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </BPSAccordionStyled>
    );
}

const HomeAccordion2 = () => {
    return (
        <BPSAccordionStyled>
            <Accordion defaultActiveKey="0" >
                <Row className="justify-content-between">
                    <Col md={5} className="order-2 order-md-1">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Exciting & reliable incentive options</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Choose from a wide range of incentive options to motivate and excite your stakeholders. Enjoy the convenience and peace of mind of working with an expert team crafting solutions customized to your unique needs.
                                </p>
                                <p>
                                    Our incentive offerings include:
                                </p>
                                <BPSCheckmarkList>
                                    <ul>
                                        <li>
                                            <Checkmark />Virtual & physical Visa prepaid rewards cards
                                        </li>
                                        <li>
                                            <Checkmark />ACH payments
                                        </li>
                                        <li>
                                            <Checkmark />Physical checks
                                        </li>
                                        <li>
                                            <Checkmark />eGift cards
                                        </li>
                                        <li>
                                            <Checkmark />Custom-branded merchandise
                                        </li>
                                        <li>
                                            <Checkmark />Name-brand products
                                        </li>
                                    </ul>
                                </BPSCheckmarkList>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>User-friendly administrator & participant portals</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Every program comes with user-friendly participant portals. Plus you get access to a powerful administrative portal. Enabling you to:
                                </p>
                                <BPSCheckmarkList>
                                    <ul>
                                        <li>
                                            <Checkmark />Review & download reporting and analytics from your program.
                                        </li>
                                        <li>
                                            <Checkmark />Communicate directly with participants.
                                        </li>
                                        <li>
                                            <Checkmark />Make or request changes to your participant site.
                                        </li>
                                        <li>
                                            <Checkmark />Validate claims.
                                        </li>
                                    </ul>
                                </BPSCheckmarkList>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Unmatched customer service & support</Accordion.Header>
                            <Accordion.Body>
                                <p>
                                    Every client is assigned a dedicated account manager. They’re always available and will meet with you every step of the way to:
                                </p>
                                <BPSCheckmarkList>
                                    <ul>
                                        <li>
                                            <Checkmark />Answer your questions.
                                        </li>
                                        <li>
                                            <Checkmark />Provide regular updates.
                                        </li>
                                        <li>
                                            <Checkmark />Ensure issues are resolved quickly and effectively.
                                        </li>
                                    </ul>
                                </BPSCheckmarkList>
                                <p className="pt-3">
                                    Additionally, our in-house customer service representatives are on the front lines for all our programs. They help to monitor your program’s success and provide unparalleled support for you and your stakeholders.
                                </p>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Col>

                    <Col md={6} className="order-1 order-md-2">
                        <Accordion.Item eventKey="0">
                            <Accordion.Body>
                                <img src={Exciting} width='90%' />
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Body>
                                <img src={UserFriendly} width='100%' />
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Body>
                                <img src={HighFive} width='90%' />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Col>
                </Row>
            </Accordion>
        </BPSAccordionStyled >
    );
}


export { HomeAccordion1, HomeAccordion2 }
